import type { FC, ReactNode } from 'react'

import CtaLink from '@/components/generals/cta-link'
import ShareButton from '@/components/landing/share-button'
import { Eyebrow } from '@/components/landing/section-intro'
import { appLinks } from '@/constants/site'

const DownloadSection: FC = (): ReactNode => {
    return (
        <section id='download' aria-labelledby='download-title' className='relative overflow-hidden border-t border-border bg-tint py-16 lg:py-24'>
            <div aria-hidden='true' className='hero-glow pointer-events-none absolute inset-0 opacity-80' />

            <div className='relative mx-auto flex max-w-7xl flex-col gap-10 px-5 sm:px-8 lg:flex-row lg:items-center lg:justify-between'>
                <div className='reveal'>
                    <Eyebrow>
                        Start with 1, 2 or 4 views for free
                    </Eyebrow>

                    <h2
                        id='download-title'
                        className='mt-4 font-heading text-[clamp(2.1rem,4.8vw,3.5rem)] font-extrabold leading-[1.03] tracking-[-0.035em] text-foreground'
                    >
                        Your videos together.
                        <br />
                        <span className='text-gradient'>
                            Your screen in control.
                        </span>
                    </h2>

                    <p className='mt-5 text-sm text-muted-foreground'>
                        For Android · Free features and optional in-app purchases
                    </p>
                </div>

                <div className='flex w-full flex-col gap-3 sm:w-auto sm:min-w-[16rem]'>
                    <CtaLink href={appLinks.playStore} external size='lg'>
                        Open Google Play
                    </CtaLink>

                    <ShareButton />
                </div>
            </div>
        </section>
    )
}

export default DownloadSection
